export default "__VITE_ASSET__BoFDJaXF__"